/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react-dom',
	'react',
	'@ba/ba-ui-carbon-toolkit',
	'prop-types',
	'jquery'
], function (ReactDOM, React, Toolkit, PropTypes, $) {

	const { List, Label } = Toolkit;

	const KEY_CODES = {
		ENTER: 13,
		UP: 38,
		DOWN: 40,
		TAB: 9,
		SPACE: 32
	};

	class DrillThroughDefinitionSelectMenu extends React.Component {

		constructor(props) {
			super(props);
			this.selectMenuRef = React.createRef();
			$(document.body).on('click', this._clickawayHandler.bind(this));
		}

		_renderMenuItem(index){
			//selectedIndex is -1 based; index is 0 based;
			const selectedIndex = index -1;
			const item = this.props.getRow(this.props.rowId);
			const selected = item.state.selectedIndex === selectedIndex;
			const value = selectedIndex === -1 ? this.props.noMappingText : item.state.values[selectedIndex];
			const className = selected ? 'dtSelectListItem dtSelected' : 'dtSelectListItem';
			const id = selected ? 'dt-activedescendant' : '';
			return (<Label aria-label={value} title={value} role='option' data-optId={selectedIndex} className={className} id = {id} label={value} />);
		}

		_getRefNode(){
			return this.selectMenuRef.current && this.selectMenuRef.current._node;
		}

		_clickawayHandler(e){
			const refNode = this._getRefNode();
			if (this.props.onClose && refNode && !refNode.contains(e.target) ){
				const parent = $(refNode).parent();
				if (parent && !parent[0].contains(e.target)){
					this.props.onClose();
				}
			}
		}

		_onSelectMenuOpened(){
			if (this.props.onSelectMenuOpened){
				this.props.onSelectMenuOpened(this._getRefNode());
			}
		}

		_onSelectValue(payload){
			if (this.props.onSelectValue){
				payload.rowId = this.props.rowId;
				this.props.onSelectValue(payload);
			}
		}

		componentDidMount(){
			this._onSelectMenuOpened();
		}

		componentWillUnmount(){
			$(document.body).off('click', this._clickawayHandler.bind(this));
		}

		render() {
			const item = this.props.getRow(this.props.rowId);
			const activeIndex = item.state.selectedIndex + 1;
			//we add a no text item;
			const length = item.state.values.length + 1 ;
			const style = { display: 'block' };
			return  (
				<List
					length={length}
					itemRenderer={this._renderMenuItem.bind(this)}
					className='dtSelectList'
					data-rowId={this.props.rowId}
					ref={this.selectMenuRef}
					onSelectionChange={this._onSelectValue.bind(this)}
					selectionMode = 'single'
					activeIndex = {activeIndex}
					style={style}
					onKeyDown={this._onKeyDown.bind(this)}
				/> );

		}

		_onKeyDown(event){
			const $node = $(this._getRefNode());
			var $current =  $node.find('span.psuedoHover');
			var next, prev = null;
			var isUpArrow = event.which === KEY_CODES.UP || event.keyCode === KEY_CODES.UP;
			var isDownArrow = event.which === KEY_CODES.DOWN || event.keyCode === KEY_CODES.DOWN;
			var isDirectionAllowed = isUpArrow || isDownArrow;
			var isEnter = event.which === KEY_CODES.ENTER || event.keyCode === KEY_CODES.ENTER;
			var isTab = event.which === KEY_CODES.TAB || event.keyCode === KEY_CODES.TAB;

			if(isTab){
				this.props.onClose();
			}

			if($current.length){
				next = $current.next();
				prev = $current.prev();

				if(isDirectionAllowed){
					//Check for hover due to mouse
					$current = $current.is(':hover') ? $current.addClass('noPsuedoHover') : $current;
					//Remove psuedo Hover
					$current  = $current.removeClass('psuedoHover');
					$current.attr('id', '');
				}
			}

			if($current.length){
				if(isEnter){
					const index = Number.parseInt($current.attr('data-optid'))+1;
					this._onSelectValue( { rowId:this.props.rowId, index: index });
				}else if (isDirectionAllowed) {
					if(isUpArrow){
						if(prev && prev.length){
							prev.addClass('psuedoHover')
								.removeClass('noPsuedoHover');
						}else{
							$node.find('span')
								.last()
								.addClass('psuedoHover')
								.removeClass('noPsuedoHover');
						}
					} else if(isDownArrow) {
						if(next && next.length){
							next.addClass('psuedoHover')
								.removeClass('noPsuedoHover');
						}else {
							$node.find('span')
								.first()
								.addClass('psuedoHover')
								.removeClass('noPsuedoHover');
						}
					}
					event.preventDefault();
					event.stopPropagation();
				}
			}else if (isDirectionAllowed){
				if(isUpArrow){
					$node.find('span')
						.last()
						.addClass('psuedoHover')
						.removeClass('noPsuedoHover');
				}else if (isDownArrow) {
					$node.find('span')
						.first()
						.addClass('psuedoHover')
						.removeClass('noPsuedoHover');
				}
				event.preventDefault();
				event.stopPropagation();
			}

			$current =  $node.find('span.psuedoHover');
			$current.attr('id', 'dt-activedescendant');
			$current.focus();
			if($current.length && !this.props.iswithinVerticalBounds($current, $node)){
				$current.get(0).scrollIntoView();
			}
		}

	}

	DrillThroughDefinitionSelectMenu.propTypes = {
		rowId: PropTypes.string,
		getRow: PropTypes.func,
		noMappingText: PropTypes.string,
		onSelectMenuOpened: PropTypes.func,
		onSelectValue: PropTypes.func,
		onClose: PropTypes.func,
		iswithinVerticalBounds: PropTypes.func
	};
	return DrillThroughDefinitionSelectMenu;
});

